// extracted by mini-css-extract-plugin
export default {"Box":"TimelineRowBorder-module__Box__kVTyoIr"};